import { EditVacationTypeDialogModel } from "./EditVacationTypeDialogModel";
import { ExtraWorkDaysModel } from "./ExtraWorkDaysModel";

export class GeneralSettingsModel {

    public deletingVacationId: string;
    public editVacationTypeDialogModel: EditVacationTypeDialogModel;
    public isEditWorkdaysDialogVisible: boolean = false;

    public constructor(
        public isInit: boolean,
        public workDays: boolean[] = [true, true, true, true, true, false, false],
        public vacationTypes: VacationTypeModel[],
        public extraWorkDays: ExtraWorkDaysModel
    ) { }

}

export class VacationTypeModel {
    public constructor(
        public id: string,
        public name: string,
        public color: string,
    ) { }
}